export enum VotingState {
  VOTED = 'hasVoted',
  HAS_NOT_VOTED = 'hasNotVoted',
}
